import {createGlobalStyle} from "styled-components";
import normalize from "styled-normalize";

const GlobalStyle = createGlobalStyle`
    ${normalize}
    * {
        box-sizing: border-box;
    }

    :root {
        /* Color properties */
        --color-white: #fff;
        --color-black: #000;

        --color-primary-40: #4B7DB9;
        --color-primary: ${({$elcid}) => $elcid ? "#253669" : "#2e65a8"};
        --color-primary-rgb: ${({$elcid}) => $elcid ? "37, 54, 105" : "46, 101, 168"};
        --color-primary-60: ${({$elcid}) => $elcid ? "#88CDE8" : "#285C9C"};

        --color-secondary: ${({$elcid}) => $elcid ? "#88CDE8" : "#8fb3e0"};
        --color-secondary-60: ${({$elcid}) => $elcid ? "#65bbdc" : "#74A0D8"};

        --color-dark: #333333;
        --color-dark-rgb: 51, 51, 51;

        --color-elcid-primary: #253669;
        --color-elcid-primary-rgb: 37, 54, 105;
        --color-elcid-secondary: #a2e4b8;
        --color-elcid-secondary-rgb: 162, 228, 184;
        --color-elcid-background: #2536690D;

        --color-background: ${({$elcid}) => $elcid ? "#FCFCFC" : "#F8FDFF"};
        --color-background-60: ${({$elcid}) => $elcid ? "#F6FAFB" : "#EEF5FB"};
        --color-background-70: ${({$elcid}) => $elcid ? "#EBF5F9" : "#E6F0F8"};

        --color-primary-btn: #E4EEF6;
        --color-primary-btn-hover: #D0DFEE;
        --color-elcid-btn-switch: #E4E9EB;
        --color-elcid-btn-switch-hover: #CED5D8;

        --color-primary-btn-on-primary: #4B7DB9;
        --color-primary-btn-on-primary-hover: #376daf;
        --color-elcid-primary-btn-on-primary: #4F5E8C;
        --color-elcid-primary-btn-on-primary-hover: #7599CB;

        --color-primary-btn-on-background: #d4e2f1;
        --color-primary-btn-on-background-hover: #c3d4e6;
        --color-elcid-primary-btn-on-background-text: #05307A;
        --color-elcid-primary-btn-on-background: #1760FF1A;
        --color-elcid-primary-btn-on-background-hover: #1760FF33;

        --color-error: #ff7d7d;

        /* Font properties */
        --font-heading: 'Jost', sans-serif;
        --font-body: 'Outfit', sans-serif;

        --fw-regular: 400;
        --fw-semi-bold: 600;
        --fw-bold: 700;

        // Font sizes desktop (1024px)
        --fs-heading-1: 6rem;
        --fs-heading-2: 4.8rem;
        --fs-heading-3: 2.8rem;
        --fs-heading-4: 1.8rem;
        --fs-body: 1.8rem;
        --fs-button: 2rem;
        --fs-navigation: 1.8rem;
        --fs-navigation-sub: 1.8rem;
        --fs-label: 1.4rem;

        @media screen and (max-width: 1024px) {
            --fs-navigation-sub: 1.6rem;
        }

        @media screen and (max-width: 768px) {
            --fs-heading-1: 3.2rem;
            --fs-heading-2: 2.8rem;
            --fs-heading-3: 2.4rem;
            --fs-heading-4: 1.6rem;
            --fs-body: 1.6rem;
            --fs-button: 1.8rem;
        }

        /* Box shadow */
        --box-shadow: 0 2px 20px 0 rgba(0, 0, 0, .1);
        --box-shadow-sponsor: 0 2px 40px 0 rgba(0, 0, 0, .05);
        --box-shadow-navbar: 0 1px 30px 0 rgba(var(--color-dark-rgb), .1);
        --box-shadow-navbar-dropdown: 0 2px 30px 0 rgba(0, 0, 0, .1);
        --box-shadow-input: 0 2px 5px 0 rgba(0, 0, 0, .07);
    }

    html, body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin: 0;
        padding: 0;
        font-size: 62.5%;
        font-family: var(--font-body), ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        background-color: var(--color-background);
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        tab-size: 4;
        font-feature-settings: normal;
    }

    /* NProgress navigation loader bar */
    #nprogress {
        pointer-events: none;
    }

    #nprogress .bar {
        background: var(--color-primary);
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;

        @media screen and (max-width: 1024px) {
            background: var(--color-secondary);
        }
    }

    .grecaptcha-badge {
        z-index: 99;
    }
`;

export default GlobalStyle;